import { type FC } from 'react'
import { selectionDisplay } from '../domain/accountTypeCatalog'
import { type ResolvedItem } from '../domain/collections'
import { NO_VALUE } from '../descriptor/stepCopy'
import { useWizardFlow } from '../hooks/WizardFlowContext'

interface PanelTypeSummaryProps {
  item: ResolvedItem
}

export const PanelTypeSummary: FC<PanelTypeSummaryProps> = ({ item }) => {
  const { accountTypes, selectors } = useWizardFlow()

  if (item.collection !== 'accounts') {
    return null
  }

  return (
    <div className='d-flex zocks-gap-1'>
      {selectionDisplay(accountTypes, selectors, item.account.selection).map((axis) => (
        <div key={axis.field} className='d-flex flex-column zocks-gap-0.25 w-100'>
          <span className='paragraph-small'>{axis.label}</span>
          <div className='paragraph-medium rounded-1 py-2 px-3 zocks-bg-color-gray-100'>{axis.value || NO_VALUE}</div>
        </div>
      ))}
    </div>
  )
}
